import { Injectable } from "@angular/core";
import { ExperienceLink, ExperienceModel } from "src/app/models/experience-link";
import { ExperienceType } from "src/app/models/experiences";

@Injectable({
  providedIn: 'root'
})
export class BookclubLinksDialogFactory {

  buildLinks(links: ExperienceLink[]): ExperienceModel[] {
    const moderateLinks: ExperienceModel = {
      label: 'bookclub.carousel.moderates',
      type: ExperienceType.MODERATES,
      experienceLinks: links.filter((link) => link.type === ExperienceType.MODERATES),
    };
    const followingLinks: ExperienceModel = {
      label: 'bookclub.carousel.followed',
      type: ExperienceType.FOLLOWING,
      experienceLinks: links.filter((link) => link.type === ExperienceType.FOLLOWING),
    };
    const plainLinks: ExperienceModel = {
      label: 'bookclub.carousel.without.enrichment',
      type: ExperienceType.PLAIN,
      experienceLinks: links.filter((link) => link.type === ExperienceType.PLAIN),
    };
    return [moderateLinks, followingLinks, plainLinks];
  }
}